import React from 'react';
import { Box, Button } from 'components';
import { Link } from 'core/routing';

export const ShipmentQuoteButton = ({
  customerSlug,
  rfqId,
}: {
  customerSlug: string;
  rfqId: string;
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Link
        name='new-quote'
        params={{
          customerSlug,
          rfqids: [rfqId],
        }}
      >
        <Button
          size='small'
          icon='arrow_right'
          iconPosition='right'
          text='Create Shipment Quote from RFQ'
          margin='0 8px 0 0'
        />
      </Link>
    </Box>
  );
};
